import React from 'react'
import "../Home/Homes.css"
import 'bootstrap/dist/css/bootstrap.min.css';     
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import intro from "../../../Images/home3.jpg"
import girl from "../../../Images/home6.jpg"
import men from "../../../Images/home5.jpg"
import kid from "../../../Images/home4.jpg"
import cos from "../../../Images/home 2.jpg"


const Home = () => {
  return (
    <div>
     {/* -------------------------------------------------------------Hero section-------------------------------------------------------------*/}

    <section className="hero-section d-flex align-items-center justify-content-center text-center">
      <div className="overlay"></div>
      <div className="content text-white">
        <h1 className="display-3 fw-bold">Celebrating 25 Years of Style & Trust</h1>
        <p className="lead mb-4">Fashion for Kids, Ladies, Men, and Cosmetics.</p>
        <div className="button d-flex justify-content-center gap-5">
        <a href="/gallery" className="btn btn-lg btn-custom">View Gallery</a>
        <a href="/contact" className="btn btn-lg btn-custom">Contact now</a>
        </div>
      </div>
    </section>

    {/* -------------------------------------------------------------Intro section-------------------------------------------------------------*/}

<section className="intro mb-3">
  <div className="row g-0">
    <div className="col-md-4">
      <img src={intro} className="img-fluid rounded-start" alt="image" />
    </div>
    <div className="col-md-8">
      <div className="intro-body mt-md-4">
        <h1 className="intro-title">Our Story of Style and Trust</h1>
        <hr className="line" />
        <p className="intro-text">
          Akshayam Textiles has been crafting style, comfort, and quality for over 25 years. 
          We are dedicated to providing families with the finest fabrics and thoughtfully designed 
          clothing. Our collections cater to every age from vibrant kidswear to elegant ladies attire, 
          stylish menswear, and premium cosmetics. Fashion reflects personality, confidence, 
          and lifestyle. By blending timeless traditions with modern trends, we ensure elegance, comfort, 
          and durability in every piece. Over the years, Akshayam Silks and Readymades has earned a reputation for excellence, 
          inspiring trust and delight among generations of families.
        </p>
        <a className="read-more" href="/about">Read More</a>
      </div>
    </div>
  </div>
</section>

    {/* -------------------------------------------------------------Category section-------------------------------------------------------------*/}

<section className="category d-flex ">
  <div class="card">
    <img src={girl} class="card-img-top" alt="Ladies wear"/>
  <div class="card-body">
    <h6>Ladies Wear</h6>
    <p class="card-text">Elegant attire blending tradition and trend for every occasion.</p>
  </div>
</div>
<div class="card">
    <img src={men} class="card-img-top" alt="mens wear"/>
  <div class="card-body">   
     <h6>Mens Wear</h6>
     <p class="card-text">Stylish, versatile clothing for work, celebrations and daily comfort.</p>
  </div>
</div>
<div class="card">
    <img src={kid} class="card-img-top" alt="kids wear"/>
  <div class="card-body">
    <h6>Kids Wear</h6>
    <p class="card-text">Colorful and comfy outfits bringing joy to every child’s day.</p>
  </div>
</div>
<div class="card">
    <img src={cos} class="card-img-top" alt="..."/>
  <div class="card-body">
    <h6>Cosmetics</h6>
    <p class="card-text">Trusted beauty products enhancing radiance, confidence and natural glow.
</p>
  </div>
</div>
</section>

    {/* -------------------------------------------------------------testimonial section-------------------------------------------------------------*/}

 <section className="testimonials ">
      <div className="testimonial holographic-card">
        <h2>“Akshayam Textiles provides the finest fabric quality with excellent service. Highly recommended!”</h2>
        
          <h6 className="fw-bold mb-0 text-info">— Priya Menon</h6>
          <small className="text-muted">Customer</small>
        
      </div>

      <div className="testimonial holographic-card second">
        <h2>“Their designs are both traditional and trendy. I always find something unique here!”</h2>
        
          <h6 className="fw-bold mb-0 text-info">— Rakesh Kumar</h6>
          <small className="text-muted">Fashion Designer</small>
        
      </div>

      <div className="testimonial holographic-card">
        <h2>“Exceptional quality and customer care! Every purchase feels worth it.”</h2>
       
          <h6 className="fw-bold mb-0 text-info">— Sneha Raj</h6>
          <small className="text-muted">Regular Buyer</small>
        
      </div>
    </section>

        {/* -------------------------------------------------------------special section-------------------------------------------------------------*/}
   <section className="special d-flex justify-content-center align-items-center">
  <div className="special-box d-flex justify-content-center align-items-center flex-column">
    <div className="heading d-flex flex-column justify-content-center align-items-center">
      <h1>What Makes Us Special</h1>
      <p>From fine fabrics to modern designs, here’s why customers love shopping with us.</p>
    </div>

    <div className="key-highlight d-flex flex-wrap justify-content-center align-items-center">
      <div className="highlight">
        <h5>Premium Fabric Quality</h5>
        <p>We source only high grade materials to ensure every outfit feels soft, durable and luxurious.</p>
      </div>
      <div className="highlight">
        <h5>Trendy & Timeless Designs</h5>
        <p>Stay in style with collections inspired by the latest fashion trends, tailored for all ages.</p>
      </div>
      <div className="highlight">
        <h5>Affordable Prices</h5>
        <p>Quality shouldn’t be expensive our pricing brings luxury within everyone’s reach.</p>
      </div>
      <div className="highlight">
        <h5>25 Years of Customer Trust</h5>
        <p>A legacy of excellence, built on customer satisfaction and long-lasting relationships.</p>
      </div>
    </div>
  </div>
</section>
    
    </div>
  )
}

export default Home
